import React from "react"

const PoisFilter = ({ availableTypes, selectedTypes, setSelectedTypes }) => {
  const fieldsetClass = type => `
      inline-block border my-1 text-xs px-2 mr-4 select-none
      ${
        selectedTypes.includes(type)
          ? "border-primary-300 bg-primary-100"
          : "border-gray-300 bg-gray-100"
      }
    `

  const checkType = ({ target: { name } }) => {
    if (selectedTypes.includes(name))
      setSelectedTypes(selectedTypes.filter(st => st !== name))
    else setSelectedTypes([...selectedTypes, name])
  }

  return availableTypes.map(type => (
    <fieldset className={fieldsetClass(type)}>
      <label htmlFor={type} className="cursor-pointer">
        {type}
      </label>
      <input
        className="ml-2 cursor-pointer"
        id={type}
        type="checkbox"
        name={type}
        checked={selectedTypes.includes(type)}
        onChange={checkType}
      />
    </fieldset>
  ))
}

export default PoisFilter
